import SydFilterView from "src/components/Common/UI/SydFilter/SydFilterView";
import SydFilterProvider from "src/components/Common/UI/SydFilter/SydFilterContext";
import SearchBilling from "./SearchBilling";
import BillingDataView from "./BillingDataView";


const defaultFilterData: IBillingSummarySearchForm = {
  year: "",
  monthName: "",
  providerID: ""
}

const BillingSummary = () => {
  
  return (
    <div className="page-content">
       <div className="text-center">
          <span className="h1">Συγκεντρωτική Οθόνη Χρεώσεων</span>
        </div>
      <SydFilterProvider
        defaultFilterData={defaultFilterData}
      >
        <SydFilterView title={"Αναζήτηση Μονάδας"}>
          <SearchBilling />
        </SydFilterView>

        <BillingDataView />
      </SydFilterProvider>
    </div>
  )

}
export default BillingSummary;